import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/modules/actions';
import { defaultOptions, checkStatus, parseJSON, getLocationOrigin } from '../../services/fetchTools';
import { colors, btn, form, card } from '../../style/common/partnerStyle';

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: colors.bg,
    padding: 24,
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    boxSizing: 'border-box',
  },
  card: {
    ...card.wrap,
    width: '100%',
    maxWidth: 400,
    padding: '48px 40px',
    textAlign: 'center',
    position: 'relative',
  },
  logo: {
    width: 56,
    height: 56,
    borderRadius: 14,
    background: colors.brand,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
    boxShadow: `0 8px 16px ${colors.brand}33`,
  },
  logoImg: {
    width: 32,
    height: 'auto',
  },
  heading: {
    fontSize: 26,
    fontWeight: 700,
    color: colors.text,
    margin: '0 0 8px',
    letterSpacing: '-0.02em',
  },
  subheading: {
    fontSize: 15,
    color: colors.muted,
    margin: '0 0 32px',
    lineHeight: 1.5,
  },
  stepIndicator: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    marginBottom: 32,
  },
  dot: (active) => ({
    width: active ? 24 : 8,
    height: 8,
    borderRadius: 4,
    background: active ? colors.brand : colors.border,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  }),
  fieldWrap: {
    marginBottom: 24,
    textAlign: 'left',
  },
  label: {
    display: 'block',
    fontSize: 12,
    fontWeight: 700,
    color: colors.muted,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: 8,
  },
  input: {
    ...form.input,
    width: '100%',
    height: 48,
    fontSize: 16,
    padding: '0 16px',
    border: `1.5px solid ${colors.border}`,
    background: colors.surface,
    transition: 'all 0.2s ease',
    outline: 'none',
    boxSizing: 'border-box',
  },
  btnPrimary: {
    ...btn.primary,
    width: '100%',
    height: 50,
    justifyContent: 'center',
    fontSize: 15,
    borderRadius: 10,
    boxShadow: `0 4px 12px ${colors.brand}40`,
    border: 'none',
    cursor: 'pointer',
  },
  btnBack: {
    ...btn.outline,
    width: '100%',
    height: 50,
    justifyContent: 'center',
    fontSize: 14,
    borderRadius: 10,
    marginTop: 12,
    border: `1px solid ${colors.border}`,
    color: colors.muted,
    background: 'transparent',
  },
  error: {
    marginTop: 24,
    fontSize: 13,
    color: colors.danger,
    background: colors.dangerLt,
    padding: '12px',
    borderRadius: 8,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  spinner: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  }
};

class Login extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      email: '',
      password: '',
      isAuthenticating: false,
      validate: false,
    };
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    isFetching: PropTypes.bool,
    locationMenu: PropTypes.object,
  };

  componentDidMount() {
    this.props.actions.enterPage('Login');
  }

  componentWillUnmount() {
    this.props.actions.leavePage('Login');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFetching !== this.props.isFetching) {
      this.setState({ isAuthenticating: this.props.isFetching });
    }
  }

  postMobile(mobile_no) {
    const url = `${getLocationOrigin()}/auth/verify_mobile_start`;
    const options = { 
      ...defaultOptions, 
      method: 'post', 
      headers: { 'content-type': 'application/json' }, 
      body: JSON.stringify({ mobile_no }) 
    };
    
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        if (response.authentication) {
          this.setState({ validate: true });
        }
      })
      .catch(error => {
        console.error("Mobile verification failed:", error);
      });
  }

  handleSubmit() {
    if (this.state.email.length >= 10) {
      this.postMobile(this.state.email);
    }
  }

  handlesOnEmailChange = (e) => {
    this.setState({ email: e.target.value.trim() });
  };

  handlesOnPasswordChange = (e) => {
    this.setState({ password: e.target.value.trim() });
  };

  handlesOnLogin = async (e) => {
    e.preventDefault();
    this.setState({ isAuthenticating: true });
    this.props.actions.loginUser(this.state.email, this.state.password);
  };

  render() {
    const { email, password, isAuthenticating, validate } = this.state;
    const { user, history, locationMenu } = this.props;

    // Check for authentication success
    if (user.data.isAuthenticated === true || user.data.isAuthenticated === 'true') {
      localStorage.setItem('isAuthenticated', user.data.isAuthenticated);
      const destination = locationMenu.access_config !== 'Technichal Partner' ? '/' : '/partnerBFC';
      history.push({ pathname: destination });
      return null;
    }

    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={s.logo}>
            <img src={require("../../img/logo.png")} alt="Logo" style={s.logoImg} />
          </div>

          <h1 style={s.heading}>{validate ? 'Verify OTP' : 'Welcome back'}</h1>
          <p style={s.subheading}>
            {validate 
              ? `Enter the 6-digit code sent to your mobile number.` 
              : 'Sign in to your account to continue'}
          </p>

          <div style={s.stepIndicator}>
            <div style={s.dot(true)} />
            <div style={s.dot(validate)} />
          </div>

          {!validate ? (
            <div key="step1">
              <div style={s.fieldWrap}>
                <label style={s.label}>Mobile Number</label>
                <input
                  type="tel"
                  style={s.input}
                  placeholder="Enter your mobile number"
                  value={email}
                  onChange={this.handlesOnEmailChange}
                  autoFocus
                />
              </div>
              <button style={s.btnPrimary} type="button" onClick={this.handleSubmit}>
                Send OTP
              </button>
            </div>
          ) : (
            <div key="step2">
              <div style={s.fieldWrap}>
                <label style={s.label}>One-time password</label>
                <input
                  type="password"
                  style={{...s.input, textAlign: 'center', letterSpacing: '0.4em'}}
                  placeholder="••••••"
                  value={password}
                  onChange={this.handlesOnPasswordChange}
                  autoFocus
                />
              </div>
              <button
                style={s.btnPrimary}
                type="button"
                disabled={isAuthenticating || password.length < 4}
                onClick={this.handlesOnLogin}>
                {isAuthenticating ? (
                  <span style={s.spinner}>
                    Signing in... <i className="fa fa-spinner fa-pulse fa-fw" />
                  </span>
                ) : 'Sign in'}
              </button>
              <button
                style={s.btnBack}
                type="button"
                onClick={() => this.setState({ validate: false })}>
                Change Number
              </button>
            </div>
          )}

          {user.data.error_message && (
            <div style={s.error}>
              <i className="fa fa-exclamation-circle" />
              {user.data.error_message}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfos:    state.userInfos.data,
  user:         state.user,
  locationMenu: state.locationMenu,
  isFetching:   state.user.isFetching,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...actions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));


// WEBPACK FOOTER //
// ./src/app/views/login/Login.js